import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import RegistrationForm from '@/components/Forms/Registration';

import { Link } from 'gatsby';

const Registration = ({ data }) => (
  <div className={styles.registr}>
    <div className={styles.registr_txt}>
      <h2 className={classnames('cr-h2', styles.registr_txt_title)}>
        {data.title}
      </h2>
      <p className={classnames('cr-lead')}>
        {data.desc}&nbsp;
        <Link
          to={data.descHighlightedLink.link || '#'}
          className={'cr-link cr-main'}
        >
          {data.descHighlightedLink.linkText}
        </Link>
      </p>
    </div>
    <div className={styles.registr_form}>
      <RegistrationForm data={data.formData} />
    </div>
  </div>
);

export default Registration;
